import React from 'react';

import * as FlipdishApi from '@flipdish/api-client-typescript';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import { getTranslate } from 'react-localize-redux';
import { useSelector } from 'react-redux';

import Select from '@fd/ui/Select/Select';

import ErrorBoundary from '../../layouts/Portal/ErrorBoundary';
import { getAllStoresOptionItem } from './constants';

const StyledSelect = styled(Select)(({ theme }) => ({
  marginTop: theme.spacing(1.5),
}));

type StoreOption = {
  label: string;
  value: number | string;
};

interface ModifyPermissionStoreSelectProps {
  dataFd: string;
  disabled?: boolean;
  handleScroll?: any;
  handleStoresChange: (permissionLevel: FlipdishApi.TeammateBase.AppAccessLevelEnum) => any;
  isLoading?: boolean;
  isNewUser?: boolean;
  onSearchQueryChange?: (eventValue: string) => void;
  permissionLevel: FlipdishApi.TeammateBase.AppAccessLevelEnum;
  stores?: StoreOption[] | null;
  suggestions: StoreOption[];
}

const ModifyPermissionStoreSelect: React.FC<ModifyPermissionStoreSelectProps> = (props) => {
  const translate = useSelector((state: AppState) => getTranslate(state.locale));

  const {
    dataFd,
    disabled,
    isLoading,
    isNewUser,
    handleScroll,
    handleStoresChange,
    onSearchQueryChange,
    permissionLevel,
    stores,
    suggestions,
  } = props;

  const suggestionsWithAllStoresOption = [
    getAllStoresOptionItem(translate('All_sales_channels') as string),
    ...suggestions,
  ];

  return (
    <ErrorBoundary identifier="modify-permission-level-select">
      <Box onScroll={handleScroll}>
        <StyledSelect
          isDisabled={disabled}
          dataFd={dataFd}
          isClearable
          isMulti
          maxChips={3}
          onChange={disabled ? undefined : handleStoresChange(permissionLevel)}
          options={suggestionsWithAllStoresOption}
          placeholder={
            isNewUser
              ? (translate('Select_sales_channels(s)') as string)
              : (translate('None') as string)
          }
          setSearchQuery={onSearchQueryChange}
          TextFieldProps={{
            fdKey: 'stores-dropdown',
            label: translate('Sales_channels') as TranslationId,
            name: 'stores-select',
          }}
          value={stores}
          variant="standard"
          isLoading={isLoading}
        />
      </Box>
    </ErrorBoundary>
  );
};

export default ModifyPermissionStoreSelect;
